const translations = {
  triggers: 'Activadores',
  scheduledFor: 'Programada para',
  open: 'Abierto',
  sla: 'SLA',
  'filters.statusReasons': 'Motivos del estado',
  'filters.statusReason': 'Motivos del estado',
  'filters.place': 'Destino',
  'filters.semaphore': 'Semáforo',
  'filters.selectSemaphore': 'Selección de semáforo',
  'filters.dates': 'Rango de fechas',
  'filters.createdBy': 'Creado por',
  'filters.externalValue': 'Valor externo',
  'filters.containsInName': 'Contiene en el nombre',
  anonymousResponse: 'Respondido anónimamente',
  selectUser: 'Seleccionar usuario',
  selectTag: 'Seleccionar tag',
  'dateOptions.overdue6Plus': 'Vencido hace 6+ días',
  'dateOptions.overdue2to5': 'Vencido hace 2-5 días',
  'dateOptions.overdue1': 'Vencido hace 1 día',
  'dateOptions.dueToday': 'Vencimiento hoy',
  'dateOptions.dueTomorrow': 'Vencimiento mañana',
  'dateOptions.due2to5': 'Vencimiento en 2-5 días',
  'dateOptions.due6to10': 'Vencimiento en 6-10 días',
  'dateOptions.due11to15': 'Vencimiento en 11-15 días',
  'dateOptions.due16to30': 'Vencimiento en 16-30 días',
  'dateOptions.due60Plus': 'Vencimiento en 60+ días',
  'slaValue.days': 'Días',
  'slaValue.hours': 'Horas',
  'slaValue.minutes': 'Minutos',
  'slaType.creationDate': 'Fecha de apertura',
  'slaType.schedulingDate': 'Fecha de agendamiento',
  'priority.critical': 'Crítica',
  'priority.high': 'Alta',
  'priority.medium': 'Media',
  'priority.low': 'Baja',
  'cardPicker.selected': 'Seleccionado',
  'cardPicker.selectOne': 'Seleccione uno',
  'types.root': 'Actividades de primer nivel',
  'types.actionPlan': 'Planes de acción',
  defaultLabel: 'Actividades'
}

export default translations
